import apiClient, { setAccessToken } from './client'
import type {
  LoginRequest,
  SignupRequest,
  GoogleAuthRequest,
  GoogleAuthResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  AuthResponse,
  RefreshTokenResponse,
  SuccessResponse,
} from '@/types/api'

export const authApi = {
  // Login with username/password
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', data)
    setAccessToken(response.data.accessToken)
    return response.data
  },

  // Signup with email/password
  signup: async (data: SignupRequest): Promise<SuccessResponse> => {
    const response = await apiClient.post<SuccessResponse>('/auth/signup', data)
    return response.data
  },

  // Google OAuth
  googleAuth: async (data: GoogleAuthRequest): Promise<GoogleAuthResponse> => {
    const response = await apiClient.post<GoogleAuthResponse>('/auth/google', data)
    if (response.data.accessToken) {
      setAccessToken(response.data.accessToken)
    }
    return response.data
  },

  // Forgot password
  forgotPassword: async (data: ForgotPasswordRequest): Promise<SuccessResponse> => {
    const response = await apiClient.post<SuccessResponse>('/auth/forgot-password', data)
    return response.data
  },

  // Reset password
  resetPassword: async (data: ResetPasswordRequest): Promise<SuccessResponse> => {
    const response = await apiClient.post<SuccessResponse>('/auth/reset-password', data)
    return response.data
  },

  // Verify email
  verifyEmail: async (userId: string, signupToken: string): Promise<SuccessResponse> => {
    const response = await apiClient.get<SuccessResponse>('/auth/verify-email', {
      params: { userId, signupToken },
    })
    return response.data
  },

  // Refresh access token
  refresh: async (): Promise<RefreshTokenResponse> => {
    const response = await apiClient.post<RefreshTokenResponse>('/auth/refresh', {})
    setAccessToken(response.data.accessToken)
    return response.data
  },

  // Logout
  logout: async (): Promise<SuccessResponse> => {
    const response = await apiClient.post<SuccessResponse>('/auth/logout', {})
    setAccessToken(null)
    return response.data
  },
}
